import { BREAKPOINTS } from '../utils/constants';
import scrollIntoViewWithOffset from '../utils/scrollIntoViewWithOffset';

const initProductStickyAtc = () => {
  const stickyAtc = document.querySelector('[data-sticky-atc-wrapper]');
  if (!stickyAtc) return;

  const header = document.querySelector('.shopify-section-group-header-group');
  const desktopMediaQuery = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`);
  const variantInputEls = document.querySelectorAll('[data-variant-input]');
  const sellingPlanInputEls = document.querySelectorAll('[data-selling-plan-radio]');
  const productControlsEl = document.querySelector('[data-product-controls]');
  const stickyAtcButton = stickyAtc.querySelector('[data-sticky-atc-btn]');
  const selectEls = stickyAtc.querySelectorAll('[data-product-sticky-atc-select]');
  const form = document.querySelector('[data-product-main] form');
  const mainAtcButton = form.querySelector('button[type="submit"]');
  const stickySectionContainer = stickyAtc.querySelector('[sticky-section-container]');
  const stickySections = document.querySelectorAll('[data-show-in-atc-bar]');
  const stickySectionButtons = [];

  const selectSection = (button) => {
    stickySectionButtons.forEach(other => other.removeAttribute('selected'));
    button.setAttribute('selected', 'selected');
    scrollIntoViewWithOffset(`#${button.dataset.target}`, stickyAtc.offsetHeight + header.offsetHeight);
  };

  const buildLinks = () => {
    if (stickySections.length) {
      stickySections.forEach((section) => {
        const stickyButton = document.createElement('button');
        stickyButton.classList.add('sticky-atc-section');
        stickyButton.textContent = section.dataset.showInAtcBar;
        stickyButton.dataset.target = section.closest('section').id;
        stickySectionContainer.appendChild(stickyButton);
        stickySectionButtons.push(stickyButton);

        stickyButton.addEventListener('click', (e) => {
          selectSection(stickyButton);
        });
      });
    }
  };

  const syncButtons = () => {
    for (const name of stickyAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.removeAttribute(name);
      }
    }
    for (const name of mainAtcButton.getAttributeNames()) {
      if (name !== 'class') {
        stickyAtcButton.setAttribute(name, mainAtcButton.getAttribute(name));
      }
    }
    stickyAtcButton.innerHTML = mainAtcButton.innerHTML;
  };

  const mainAtcBtnObserver = new MutationObserver(syncButtons);
  syncButtons();
  buildLinks();
  mainAtcBtnObserver.observe(mainAtcButton, {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
  });

  // Controlls and functions for sticky ATC
  if (stickyAtc && productControlsEl) {
    const getBottom = el => el.getBoundingClientRect().top + window.scrollY + el.offsetHeight;
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const containerBottom = getBottom(productControlsEl);
      if (scrollY >= containerBottom) {
        stickyAtc.classList.remove('hidden');
        stickyAtc.classList.add('!z-19');
      } else {
        stickyAtc.classList.add('hidden');
        stickyAtc.classList.remove('!z-19');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  stickyAtcButton.addEventListener('click', () => {
    if (desktopMediaQuery.matches) {
      mainAtcButton.click();
    } else {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  if (!variantInputEls.length && !sellingPlanInputEls.length) return;

  const allInputEls = [...variantInputEls, ...sellingPlanInputEls];

  const updateStickySelect = (variantInput) => {
    if (variantInput.checked === true) {
      selectEls.forEach(select => {
        if (select.name.includes(variantInput.name)) {
          select.value = variantInput.value;
        }
      });
    }
  };

  const updateStickyAtcVariant = (event) => {
    const target = event.target;
    allInputEls.forEach((inputEl) => {
      if (inputEl.value === target.value && target.name.includes(inputEl.name)) {
        inputEl.checked = true;
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  allInputEls.forEach(inputEl => {
    updateStickySelect(inputEl);

    inputEl.addEventListener('change', () => {
      updateStickySelect(inputEl);
    });
  });
  selectEls.forEach(select => select.addEventListener('change', updateStickyAtcVariant));
};

export default initProductStickyAtc;
